(() => {
  const section = document.querySelector('.td-home__google-reviews');
  const root = section?.querySelector('#grp-entangle--root');
  const source = section?.querySelector('.td-home__reviews-source a');
  if (!section || !root || !source) return;

  const keyboardControls = new WeakSet();
  let sizingFrame = 0;
  let animateUntil = 0;
  const syncVisibleSlides = () => {
    sizingFrame = 0;
    const viewport = root.querySelector('.slider-wrapper');
    if (!viewport) return;
    const bounds = viewport.getBoundingClientRect();
    if (!bounds.width) return;
    root.querySelectorAll('.grp-slider-slide').forEach((slide) => {
      const rect = slide.getBoundingClientRect();
      const visible = Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > 1;
      slide.dataset.tdReviewVisible = String(visible);
      slide.setAttribute('aria-hidden', String(!visible));
      slide.toggleAttribute('inert', !visible);
    });
    if (performance.now() < animateUntil) sizingFrame = requestAnimationFrame(syncVisibleSlides);
  };
  const queueSizing = (animate = false) => {
    if (animate) animateUntil = performance.now() + 500;
    if (!sizingFrame) sizingFrame = requestAnimationFrame(syncVisibleSlides);
  };
  const enhance = () => {
    root.querySelectorAll('.grp-entangle-item-head-logo-wrapper a').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || href === '#') {
        link.href = source.href;
        link.setAttribute('aria-label', section.dataset.reviewSourceLabel);
      }
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    });

    root.querySelectorAll('.grp-entangle-rating').forEach((rating) => {
      const score = rating.querySelectorAll('.grp-full-star').length
        + rating.querySelectorAll('.grp-half-star').length / 2;
      if (score <= 0 || score > 5) return;
      rating.setAttribute('role', 'img');
      rating.setAttribute('aria-label', section.dataset.reviewStarsLabel.replace('__RATING__', String(score)));
    });

    root.querySelectorAll('.grp-slider-arrow').forEach((control) => {
      control.setAttribute('role', 'button');
      control.tabIndex = 0;
      control.setAttribute('aria-label', control.classList.contains('grp-slider-prev-grp-entangle--root')
        ? section.dataset.reviewPreviousLabel : section.dataset.reviewNextLabel);
      if (keyboardControls.has(control)) return;
      keyboardControls.add(control);
      control.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        control.click();
      });
    });

    root.querySelectorAll('button').forEach((button, index) => {
      if (button.textContent.trim() || button.getAttribute('aria-label')) return;
      button.setAttribute('aria-label', section.dataset.reviewPageLabel.replace('__NUMBER__', String(index + 1)));
    });
  };

  enhance();
  const observer = new MutationObserver((records) => {
    if (records.some((record) => record.type === 'childList')) enhance();
    queueSizing(records.some((record) => record.type === 'attributes' && record.target.classList.contains('slider-track')));
  });
  observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  const resizeObserver = new ResizeObserver(() => queueSizing());
  resizeObserver.observe(root);
  root.addEventListener('transitionend', (event) => {
    if (event.target.classList.contains('slider-track')) queueSizing();
  });
  queueSizing();
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    resizeObserver.disconnect();
    cancelAnimationFrame(sizingFrame);
  }, { once: true });
})();
